import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-small",
  "use": "plus-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"plus-small\">\r\n  <path d=\"M14 7.5v1H8.5V14h-1V8.5H2v-1h5.5V2h1v5.5H14z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol